import React, { useState, useEffect } from 'react';
import { adminService } from '@/services/adminService';
import WebsiteLoadingScreen from './WebsiteLoadingScreen';
import FinanceLandingPageSkeleton from '@/pages/FinanceLandingPageSkeleton';
import ZorgLandingPageSkeleton from '@/pages/ZorgLandingPageSkeleton';

/**
 * HomepageRouter
 * Checks which campaign landing page is active (if any).
 * Priority: finance > zorg > fallback (normal homepage).
 * 
 * Shows the cached campaign skeleton first, then renders the active page.
 */
function HomepageRouter({ fallback, campaign, financeCampaign }) {
  // Use localStorage only to choose the correct skeleton while settings load.
  const [cachedPage] = useState(() => {
    try {
      return localStorage.getItem('activeCampaign') || 'fallback';
    } catch {
      return 'fallback';
    }
  });
  const [activePage, setActivePage] = useState(null);

  useEffect(() => {
    async function checkCampaign() {
      try {
        const response = await adminService.getPublicSettings();
        if (response.success) {
          const { isFinanceLandingPageActive, isZorgLandingPageActive } = response.data;
          let currentActive = 'fallback';

          if (isFinanceLandingPageActive === true) {
            currentActive = 'finance';
          } else if (isZorgLandingPageActive === true) {
            currentActive = 'zorg';
          }

          setActivePage(currentActive);
          
          // Cache for next load
          try {
            localStorage.setItem('activeCampaign', currentActive);
          } catch (e) {
            console.warn('Unable to cache active campaign:', e);
          }
        } else {
          setActivePage('fallback');
        }
      } catch {
        setActivePage('fallback');
      }
    }
    checkCampaign();
  }, []);

  if (activePage === null) {
    if (cachedPage === 'finance') return <FinanceLandingPageSkeleton />;
    if (cachedPage === 'zorg') return <ZorgLandingPageSkeleton />;
    return <WebsiteLoadingScreen />;
  }

  if (activePage === 'finance') return financeCampaign;
  if (activePage === 'zorg') return campaign;
  return fallback;
}

export default HomepageRouter;
